/*  =============================================
    Copyright © Hugo B.V. (acting under the brand name "Quriobot") - All Rights Reserved
    =============================================

    - Unauthorized copying of this file, via any medium is strictly prohibited
    - Proprietary and confidential
    - By using the Quriobot Website and/or Services, you signify you have read and
      accepted the Terms of Service on https://quriobot.com/terms of this Website and Services.
      If you do not agree to these Conditions, do not use Quriobot Website and/or Services.
    - Written by the good people of Hugo B.V. (acting under the brand name "Quriobot"), hello@quriobot.com, December 2016

    ============================================= */

var PanelPieSlider = new Class({
  Extends: QuriobotElement,
  initialize: function (args, naturalDelayConfig, variables) {
    var meta = args[0].meta
    var arr = [
      'min_value_label',
      'max_value_label',
      'label_left',
      'label_right',
      'amount_placeholder',
      'value_type',
      'go_button_text',
      'initial_value',
    ]
    arr.map(function (item) {
      if (typeof meta[item] === 'undefined') meta[item] = ''
    })

    this.parent(args, naturalDelayConfig, variables)
  },
  template: function () {
    var base =
      '<div class="panel--wrapper panel--pieslider isLoading" family="{{ key }}" id="{{ eid }}">' +
      '    <div id="pieslider-data">' +
      '        <div id="pieslider_data_min_value">{% min_value %}</div>' +
      '        <div id="pieslider_data_max_value">{% max_value %}</div>' +
      '        <div id="pieslider_data_initial_value">{% initial_value %}</div>' +
      '        <div id="pieslider_data_value_type">{% value_type %}</div>' +
      '        <div id="pieslider_data_step_size">{% step_size %}</div>' +
      '    </div>' +
      '    <div class="panel--main">' +
      '        <div class="panel--content">' +
      '            <div class="pieslider--header" aria-hidden="true">' +
      '                <div class="label-min-max" id="label-min"><span class="label-title">{% min_value_label %}</span><span class="label-value">{% min_value %}</span></div>' +
      '                <div class="label-min-max" id="label-max"><span class="label-title">{% max_value_label %}</span><span class="label-value">{% max_value %}</span></div>' +
      '                <div id="pieslider_graph">' +
      '                    <svg id="pieslider_graphs">' +
      '                        <circle class="graph--base" r="90" cx="100" cy="100" id="graph--base"></circle>' +
      '                        <circle class="graph--pay"  r="90" cx="100" cy="100" id="graph--pay"></circle>' +
      '                    </svg>' +
      '                    <div id="pieslider_start_arrow" class="pieslider_limiter"></div>' +
      '                    <div id="pieslider_current_value_arrow" class="pieslider_limiter"></div>' +
      '                    <div class="percentage" id="pieslider_percentage">' +
      '                        {% initial_value %}{% value_type %}' +
      '                    </div>' +
      '                </div>' +
      '            </div>' +
      '            <div class="pieslider--form">' +
      '                <div class="inline--input" aria-label="{{ title }}">' +
      '                    <button type="button" aria-label="{% label_left %}" class="pm--button minus"></button>' +
      '                    <button type="button" aria-label="{% label_right %}" class="pm--button plus"></button>' +
      '                    <div class="button-label" id="button-label-left" aria-hidden="true">{% label_left %}</div>' +
      '                    <div class="button-label" id="button-label-right" aria-hidden="true">{% label_right %}</div>' +
      '                    <label class="amount-label" aria-hidden="true">{% amount_placeholder %}</label>' +
      '                    <input type="number" inputmode="decimal" lang="{{ language }}" id="id_current_amount" aria-label="{% amount_placeholder %}" placeholder="{% initial_value %}" step="{% step_size %}" value="{% initial_value %}" min="{% min_value %}" max="{% max_value %}"/>' +
      '                </div>' +
      '            </div>' +
      '        </div>' +
      '        <div class="pieslider--footer">' +
      '            <button type="button" class="go--button">' +
      '                <p class="go--button__text">{% go_button_text %}</p>' +
      '                <div class="goarrow">' +
      '                    <div class="goarrow--body"></div>' +
      '                </div>' +
      '            </button>' +
      '        </div>' +
      '        <div class="panel--overlay">' +
      '            <div class="icon--checkWrapper fromBottom circle">' +
      '                <div class="check"></div>' +
      '            </div>' +
      '            <button type="button" aria-label="' +
      this.data.i18n.redo.button.title +
      '" aria-hidden="true" class="icon--redoWrapper">' +
      '                <div class="redo"></div>' +
      '            </button>' +
      '        </div>' +
      '    </div>' +
      '</div>'

    return { base: base }
  },
  pieslider: {},
  drawCircle: function () {
    var circle_length_px = 180 * Math.PI, // 2*PI*R => 2*PI*90 => 180*PI
      current_relative_value = this.graph_current_value - this.graph_min_value,
      actual_pie_size_deg = (current_relative_value / this.length) * 360,
      actual_pie_size_percents = (current_relative_value / this.length) * 100,
      actual_pie_size_px = (circle_length_px / 100) * actual_pie_size_percents

    this.graph.setStyles({
      'stroke-dasharray': actual_pie_size_px + ',' + circle_length_px,
    })

    this.graph_current_arrow.setStyles({
      transform: 'rotate(' + actual_pie_size_deg + 'deg)',
      '-webkit-transform': 'rotate(' + actual_pie_size_deg + 'deg)',
    })
  },
  movePiesliderLimiter: function (event, snap) {
    var circle = this.circle,
      rect = circle.getBoundingClientRect(),
      center = {
        x: rect.left + rect.width / 2,
        y: rect.top + rect.height / 2,
      },
      rotate = function (x, y) {
        var deltaX = x - center.x,
          deltaY = y - center.y,
          angle = (Math.atan2(deltaY, deltaX) * 180) / Math.PI + 90

        if (angle <= 0 && this.lastAngle < 90) {
          return this.lastAngle
        } else if (angle >= 0 && this.lastAngle > 300) {
          return this.lastAngle
        } else if (angle < 0) {
          angle += 360
        }

        this.lastAngle = angle

        return angle
      },
      circle_length_px = 180 * Math.PI,
      actual_pie_size_deg = rotate(event.page.x, event.page.y)

    var graph_current_value = Math.round((actual_pie_size_deg / 360) * this.length) + this.graph_min_value
    if (snap) {
      var diff = Math.floor((graph_current_value - this.graph_min_value) / this.step_size) * this.step_size
      graph_current_value = this.graph_min_value + diff
    }
    if (graph_current_value > this.graph_max_value) {
      graph_current_value = this.graph_max_value
    } else if (graph_current_value < this.graph_min_value) {
      graph_current_value = this.graph_min_value
    }
    this.graph_current_value = graph_current_value
    this.requestUpdate()
    this.updatePercentage()
    this.input.set('value', this.graph_current_value)

    this.graph_current_arrow[0].setStyles({
      transform: 'rotate(' + actual_pie_size_deg + 'deg)',
      '-webkit-transform': 'rotate(' + actual_pie_size_deg + 'deg)',
    })
  },
  updatePercentage: function (percentage) {
    this.graph_pct.set('html', this.formatValue(this.graph_current_value) + this.value_type)
  },
  percentageUpDown: function (direction) {
    switch (direction) {
      case 'up':
        this.graph_current_value += this.step_size
        if (this.graph_current_value > this.graph_max_value) {
          this.graph_current_value = this.graph_max_value
        }
        break
      case 'down':
        this.graph_current_value -= this.step_size
        if (this.graph_current_value < this.graph_min_value) {
          this.graph_current_value = this.graph_min_value
        }
        break
    }
    if (this.graph_current_value >= this.graph_min_value && this.graph_current_value <= this.graph_max_value) {
      this.input.set('value', this.graph_current_value)
      this.updatePercentage()
      this.requestUpdate()
    }
  },
  updatePieSlider: function (data) {
    this.drawCircle()
  },
  requestUpdate: function () {
    var apiData = {}
    this.apiCallback(apiData, this.updatePieSlider.bind(this))
  },
  formatValue: function (value) {
    return numeral(parseFloat(value)).format(this.format)
  },
  attach: function () {
    this.pieslider = {}
    this.input = this.element.getElements('#id_current_amount')
    this.button = this.element.getElements('.go--button')[0]
    this.updown = this.element.getElements('.pm--button')
    this.graph = this.element.getElements('#graph--pay')
    this.graph_min_value = this.element.getElements('#pieslider_data_min_value')[0].textContent * 1
    this.graph_max_value = this.element.getElements('#pieslider_data_max_value')[0].textContent * 1
    this.graph_current_value = this.element.getElements('#pieslider_data_initial_value')[0].textContent * 1
    this.graph_current_arrow = this.element.getElements('#pieslider_current_value_arrow')
    this.graph_pct = this.element.getElements('#pieslider_percentage')
    this.value_type = this.element.getElements('#pieslider_data_value_type')[0].textContent
    this.step_size = this.element.getElements('#pieslider_data_step_size')[0].textContent * 1
    this.circle = this.element.getElements('#pieslider_graph')[0]
    ;(this.length = this.graph_max_value - this.graph_min_value), (this.lastAngle = 0)
    this.format = '0'

    var meta = this.data.meta
    if (meta && meta.need_trailing_zeroes) {
      this.format = this.format + '.00'
    }
    if (meta && meta.need_thousand_seperator) {
      this.format = '0,' + this.format
    }
    var numberCheck = function (val) {
      return !isNaN(parseFloat(val)) || val === ''
    }

    var movePiesliderLimiter = this.movePiesliderLimiter.bind(this)

    this.graph_current_arrow[0].addEvents({
      mousedown: function (event) {
        event.preventDefault()
        this.graph_current_arrow.setStyles({
          transition: 'none',
        })
        this.graph[0].setStyles({
          transition: 'none',
        })
        this.circle.addEvent('mousemove', movePiesliderLimiter)
      }.bind(this),

      // for touch devices
      touchstart: function (event) {
        event.preventDefault()
        this.graph_current_arrow.setStyles({
          transition: 'none',
        })
        this.graph[0].setStyles({
          transition: 'none',
        })
        this.circle.addEvent('touchmove', movePiesliderLimiter)
      }.bind(this),
    })

    this.circle.addEvents({
      mouseup: function (event) {
        this.circle.removeEvent('mousemove', movePiesliderLimiter)
        movePiesliderLimiter(event, true)
        this.graph_current_arrow.setStyles({
          transition: 'all .25s',
        })
        this.graph.setStyles({
          transition: 'all .5s',
        })
      }.bind(this),

      touchend: function (event) {
        this.circle.removeEvent('touchmove', movePiesliderLimiter)
        movePiesliderLimiter(event, true)
        this.graph_current_arrow.setStyles({
          transition: 'all .25s',
        })
        this.graph.setStyles({
          transition: 'all .5s',
        })
      }.bind(this),
    })

    this.input.addEvents({
      input: function (e) {
        var a = e.target.value
        if (numberCheck(a)) {
          // check for numeric value and empty input
          a = parseFloat(a) // convert to number
          var diff = Math.floor((a - this.graph_min_value) / this.step_size) * this.step_size
          a = this.graph_min_value + diff
          if (a < this.graph_min_value) {
            this.graph_current_value = this.graph_min_value
          } else if (a > this.graph_max_value) {
            this.graph_current_value = this.graph_max_value
            e.target.value = this.graph_max_value
          } else if (a >= this.graph_min_value && a <= this.graph_max_value) {
            this.graph_current_value = a
          }
          this.updatePercentage()
          this.requestUpdate()
        }
      }.bind(this),
      blur: function (e) {
        e.target.value = this.graph_current_value
      }.bind(this),
    })

    this.button.addEvents({
      click: function () {
        if (this.graph_current_value >= this.graph_min_value && this.graph_current_value <= this.graph_max_value) {
          this.after()
        }
      }.bind(this),
    })

    this.updown.each(
      function (oButton, index) {
        oButton.addEvents({
          click: function () {
            if (oButton.hasClass('minus')) {
              this.percentageUpDown('down')
            } else {
              this.percentageUpDown('up')
            }
          }.bind(this),
        })
      }.bind(this)
    )

    this.requestUpdate()
  },
  after: function () {
    var answerData = {
      answer: {
        render: false,
        value: this.graph_current_value,
        content: this.formatValue(this.graph_current_value),
      },
    }

    this.element.addClass('isAnswered')
    this.answerCallback(this.data, answerData)

    // Add `aria-hidden="true"` after answering to the question
    this.setAriaHidden('.panel--content', true)
    this.setAriaHidden('.pieslider--footer', true)

    // Remove `aria-hidden="true"` from redo-button
    this.setAriaHidden('.icon--redoWrapper', false)
  },
})
